import { useEffect, useState } from "react";
import TableComponent from "../../components/TableComponent";
import { ColumnHeaderType, LoggedUserType } from "../../utils/Types";
import { CLICK_ACTIONS, DEFAULT_OPTION } from "../../utils/Constant";
import Footer from "../../components/Footer";
import { USER_ACCESS_HEADERS } from "./UserAccessHelper";
import ViewUserDetailsModal from "../../modals/ViewUserDetailsModal";
import { handleStoreDeleteUserRes, handleStoreRoleStatus, handleStoreUpdateUserResponse } from "../../redux/slices/roleMasterSlice";
import { useDispatch, useSelector } from "react-redux";
import { getAllRoles, getUserMasterApi } from "../../api/roleMasterApi";
import CenterSpinner from "../../components/CenterSpinner";
import UserAccessFilters from "../../filters/UserAccessFilters";
import { USER_STATUS } from "../../utils/Constant";
import { UserAccessFilterType } from "../../models/DashboardModels";
import DeleteUserConfirmModal from "../../modals/DeleteUserConfirmModal";
import { loginSelector } from "../../redux/slices/loginSlice";
import { blankValueGetter } from "../../utils/Util";

const UserAccess = () => {
    const [filters, setFilters] = useState<UserAccessFilterType>(
        {
            email: "",
            role: DEFAULT_OPTION,
            status: DEFAULT_OPTION,
        }
    );
    const [count, setCount] = useState(0);
    const [totalCount, setTotalCount] = useState(0);
    const [openViewModal, setOpenViewModal] = useState(false);
    const [limitStart, setLimitStart] = useState(0);
    const [limitSelected, setLimitSelected] = useState(25);
    const [userData, setUserData] = useState({});
    const [flag, setFlag] = useState(false)
    const [openDeleteModal, setOpenDeleteModal] = useState(false);
    const [selectedUserId, setSelectedUserId] = useState(null);
    const [selectedUserName, setSelectedUserName] = useState(null);
    const user: LoggedUserType = useSelector(loginSelector).user;
    const [tableHeaders, setTableHeaders] = useState(USER_ACCESS_HEADERS);

    const {
        storeUserMasterData,
        showLoader,
      } = useSelector((state: any) => state.roleMaster);

    const [userAccessData, setUserAccessData] = useState(storeUserMasterData);

    const roleStatusList =
        Object.entries(USER_STATUS).map(
            ([label, value]) => ({
                label,
                value: value.toString(),
            })
        );
    
    const dispatch: any = useDispatch();
    
    useEffect(()=>{
        dispatch(handleStoreRoleStatus(roleStatusList));
        dispatch(getAllRoles());
    },[])

    useEffect(() => {
        setTimeout(() => {
            getUserMasterData();
        }, 100)
    }, [filters,flag])
    
   const getUserMasterData = () => {
    dispatch(getUserMasterApi(filters));   
};

useEffect(() => {   

    setTotalCount(storeUserMasterData.length);
    let limitedData = storeUserMasterData.slice(limitStart, limitStart + limitSelected);
    setUserAccessData(limitedData);
}, [limitStart, limitSelected, storeUserMasterData, filters]);

    const changePaginationLimit = (value: number) => {
        setLimitSelected(Number(value))
    };
    
    const prevPage = () => {
        if (limitStart >= limitSelected) {
            setLimitStart(limitStart - limitSelected)
        }
    };

    const nextPage = () => {
        if (userAccessData.length == limitSelected) {
            setLimitStart(limitStart + limitSelected);
        }
    };

    const onTableAction = (each: any, headerItem: ColumnHeaderType) => {
        if (headerItem.action === CLICK_ACTIONS.VIEW_USER) {
            toggleViewUser(each);
        } 
        else if (headerItem.action === CLICK_ACTIONS.DELETE_USER) {
            setSelectedUserId(each.id);
            setSelectedUserName(each.username);
            toggleDeleteUser();
        }
    };

    const toggleViewUser = ( data? : any) => {
        setOpenViewModal(!openViewModal);
        setUserData(data);
        if(openViewModal || !data) {
           dispatch(handleStoreUpdateUserResponse({}));
           if(flag){
            setTimeout(() => {
                getUserMasterData();
                setFlag(false);
            }, 100)
           }
        }
    }

    const toggleDeleteUser = () => {
        setOpenDeleteModal(!openDeleteModal);
        if(openDeleteModal) {
           dispatch(handleStoreDeleteUserRes({}));
           if(flag){
            setTimeout(() => {
                getUserMasterData();
                setFlag(false);
            }, 100)
           }
        }
    }

    useEffect(() => {
        const headers = user?.permissions?.includes('delete-user')
            ? [...USER_ACCESS_HEADERS, 
                {
                    name: 'Action',
                    field: 'action',
                    sortable: false,
                    valueGetter: blankValueGetter,
                    action: CLICK_ACTIONS.DELETE_USER,
                    clickable: true,
                }]
            : USER_ACCESS_HEADERS;
        setTableHeaders(headers);
    }, [user])
    return (
        <>
            <div style={{ marginBottom: '66px', overflow: 'auto' }}>
                <p className="page-header">User Access</p>

                {openViewModal && 
                    <>
                        <ViewUserDetailsModal 
                            userData={userData}
                            toggle={toggleViewUser} 
                            openViewModal={openViewModal}
                            setFlag={setFlag}
                        />
                    </>
                }

                <UserAccessFilters onApplyFilters={(updatedFilters) => setFilters(updatedFilters)} />
                <div className="table-container2">
                    <TableComponent 
                        onAction={onTableAction}
                        data={userAccessData} 
                        style={{ marginBottom: '66px' }}
                        columnHeaders={tableHeaders}
                    />

                    {userAccessData && userAccessData.length === 0 &&
                        <p className="nodata">Data Not Found</p>
                    }
                </div>

                <Footer
                    count={count} totalCount={totalCount}
                    changePaginationLimit={changePaginationLimit}
                    nextPage={nextPage}
                    prevPage={prevPage}
                    limitSelected={limitSelected}
                    limitStart={limitStart}
                />
            </div>
            <CenterSpinner showLoader={showLoader} />
            
        {openDeleteModal && (
            <DeleteUserConfirmModal
                openModal={openDeleteModal}
                toggle={toggleDeleteUser}
                userId={selectedUserId}
                userName={selectedUserName}
                setFlag={setFlag}
            />
        )}
        </>
    );
}

export default UserAccess;